export default {"src":"/_next/static/media/logo-CCA.abb8ec02.svg","height":42,"width":40,"blurWidth":0,"blurHeight":0};